import { useIsMinDesktopSize } from "~/common/hooks/useMediaQuery";
import Card, { CardSize } from "~/common/components/Card";
import { useOnMount } from "~/common/hooks/useOnMount";

interface Props {
  url: string;
}

const IFRAME_ID = "cadIframe";

export const EwellixCadTab = ({ url }: Props) => {
  const isDesktop = useIsMinDesktopSize();

  useOnMount(() => {
    window.iFrameResize?.({ log: false }, `#${IFRAME_ID}`);
  });

  return (
    <Card size={CardSize.SMALL} className={"scha__ignore-margins " + (isDesktop ? undefined : "w-100")}>
      <iframe className="scha__pdp-iframe" id={IFRAME_ID} src={url} scrolling="yes" />
    </Card>
  );
};
